import EFTB from '@images/etiqa logo/EFTB-EN.png';
import ELIB from '@images/etiqa logo/ELIB-EN.png';

export default {
  takafulTitle: 'i-MedicalCard Elite',
  insuranceTitle: 'EzyMedical',
  gabTitle: 'EasyHealth First',
  logo: {
    takaful: EFTB,
    insurance: ELIB,
  },
};
